import { render, staticRenderFns } from "./assays-view-batch-modal-assays.vue?vue&type=template&id=caa3fbde&scoped=true&"
import script from "./assays-view-batch-modal-assays.ts?vue&type=script&lang=ts&"
export * from "./assays-view-batch-modal-assays.ts?vue&type=script&lang=ts&"
import style0 from "./assays-view-batch-modal-assays.scss?vue&type=style&index=0&id=caa3fbde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa3fbde",
  null
  
)

export default component.exports